module.exports = __webpack_public_path__ + "static/media/vibinex-black-vertical.2f990dfb.svg";